import RecentInvestmentsWidget from './RecentInvestmentsWidget'

export default RecentInvestmentsWidget
